import styled from "styled-components";
import { constants } from "@thecb/components";
import { COOL_GREY, WHITE } from "@/constants/colors";
import { CONTENT_MAX_WIDTH } from "@/constants/layout";

const { SPACING } = constants.styleConstants;

/**
 * PageContainer
 *
 * Centers a page's content column and holds a gutter between it and the window
 * edge. Child components should not be wider than this container. Pair w/
 * PageContent and keep anything wider than the column in a ScrollArea
 */
export const PageContainer = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  padding: 0 ${SPACING.MD};
`;

/**
 * PageContent
 *
 * The centered column. Tracks the viewport and caps at the standard content
 * width; carries no min-width floor on purpose: a floor is what forces the
 * unreachable overflow this layout exists to avoid. `$align` sets how children
 * are sized across the column and defaults to filling it.
 */
export const PageContent = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: ${({ $align }) => $align || "stretch"};
  width: 100%;
  min-width: 0;
  max-width: ${CONTENT_MAX_WIDTH};
`;

/**
 * ScrollArea
 *
 * Holds a child wider than the column, typically a results table, at its own
 * width and contains it
 */
export const ScrollArea = styled.div`
  width: 100%;
  max-width: 100%;
  overflow-x: auto;
  scrollbar-width: thin;
  scrollbar-color: ${COOL_GREY} transparent;

  &::-webkit-scrollbar {
    height: 12px;
    -webkit-appearance: none;
  }

  &::-webkit-scrollbar-thumb {
    background: ${COOL_GREY};
    border: 3px solid ${WHITE};
    border-radius: 6px;
  }
`;
